import React, { useState, useContext, useEffect } from 'react';
import DaumPostcode from 'react-daum-postcode';
import Modal from 'react-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import CustomModal from './CustomModal';
import UtilController from '../../controller/UtilController';
import { useOutletContext } from 'react-router-dom';
import { AuthContext } from '../../navigation/AuthProvider';
import { useToast } from '../../controller/ToastController';
import StoreController, { CurrentStoreContext } from '../../controller/StoreController';
import AsyncLocalStorage from '../../utils/AsyncLocalStorage';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

const AddMultiStoreModal = ({ isVisible, setVisible }: Props) => {
  const showToast = useToast();
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const [addressModal, setAddressModal] = useState<boolean>(false);
  const [storeName, setStoreName] = useState<string>('');
  const [storeNameEn, setStoreNameEn] = useState<string>('');
  const [bCode, setBcode] = useState<string>('');
  const [sAddress, setAddress] = useState<string>('');
  const [sExtraAddress, setExAddress] = useState<string>('');
  const [sPhoneNm, setPhoneNm] = useState<string>('');
  const [multiLogoImage, setMultiLogoImage] = useState<string | null>(null);
  const [logoMediaId, setLogoMediaId] = useState<number | null>(null);

  const onCloseModal = () => {
    resetForm();
    setVisible(false);
  };

  // onChange
  const onChange_storeName = (event: any) => {
    setStoreName(event.target.value);
  };
  const onChange_storeName_en = (event: any) => {
    setStoreNameEn(event.target.value);
  };
  const onChange_sAddress = (event: any) => {
    setAddress(event.target.value);
  };
  const onChange_sExtraAddress = (event: any) => {
    setExAddress(event.target.value);
  };
  const onChange_phoneNumber = (event: any) => {
    setPhoneNm(event.target.value);
  };

  // 다음주소검색
  const handleComplete = async (data: any) => {
    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }
    setAddress(fullAddress);
    setAddressModal(false);
    setBcode(data.bcode);
  };
  const handleAddressModalClose = () => {
    setAddressModal(false);
  };

  // 이미지 등록
  const uploadLogoImage = async (e: any) => {
    console.log('files', e.target.files);
    let origin = e.target.files[0];
    if (origin !== undefined) {
      if (origin.type !== undefined && origin.type !== null) {
        if (origin.type === 'image/png' || origin.type === 'image/jpeg') {
          const formData = new FormData();
          formData.append('file', origin);
          const oRes = await UtilController.storeLogoUploadImg(formData, userInfo.user_id);
          console.log('storeLogoUploadImg', oRes);
          if (oRes.data) {
            const oResponse = oRes.data;
            console.log('oResponse.data', oResponse.data);
            if (oResponse.ok && oResponse.data) {
              setMultiLogoImage(oResponse.data.url_path);
              setLogoMediaId(oResponse.data.store_media_id);
            } else {
              showToast('파일 이름이 너무 길거나 형식에 맞지 않아요', 'error');
            }
          }
          return;
        }
      }
    }
  };
  const deleteLogoImage = () => {
    setMultiLogoImage(null);
    setLogoMediaId(null);
  };

  // console.log('logoMediaId>>>', logoMediaId);
  const errorSetMultiStore = () => {
    if (storeName === '') {
      return '매장명을 입력해주세요.';
    } else if(storeNameEn === ''){
      return '영문 매장명을 입력해주세요.';
    } else if (sAddress === '') {
      return '매장 주소를 입력해주세요.';
    } else if (sExtraAddress === '') {
      return '매장 상세 주소를 입력해주세요.';
    } else if (sPhoneNm === '') {
      return '매장 전화번호를 입력해주세요.';
    } else if (logoMediaId === null) {
      return '로고 이미지를 등록해주세요.';
    }
    return null;
  };
  const resetForm = () => {
    setStoreName('');
    setAddress('');
    setExAddress('');
    setPhoneNm('');
    setLogoMediaId(null);
    setMultiLogoImage(null);
  };

  // 멀티매장 등록
  const setMultiStore = async () => {
    const validationError = errorSetMultiStore();
    if (validationError) {
      return showToast(validationError, 'error');
    }

    try {
      const oParams = {
        user_id: userInfo.user_id,
        store: {
          store_name: storeName,
          store_name_en: storeNameEn,
          address1: sAddress,
          address2: sExtraAddress,
          phone_number: sPhoneNm,
          store_media_id: logoMediaId,
          bcode: bCode,
        },
      };
      const oRes: any = await StoreController.setStore(oParams);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data;

        if (oResponse.ok) {
          let userDataTemp = await AsyncLocalStorage.getItem('ceo-userData');
          userDataTemp.store_list = oResponse.data.store_list;
          AsyncLocalStorage.setItem('ceo-userData', JSON.stringify(userDataTemp));
          setUserInfo(userDataTemp);
          showToast('새로운 멀티매장이 등록되었습니다.');
          resetForm();
          setVisible(false);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onCloseModal}
      className="addMultiStoreModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}>
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
            alt="close"
          />
          <div className="modal_header">
            <div className="headerBar" />
            <h2>멀티매장 추가하기</h2>
          </div>
          <h5 className="comment">
            {
              '멀티매장이란, 동일한 사업자번호에 여러개의 브랜드(업종)를 운영 중인 매장입니다.\n매장 수가 추가된 만큼 광고료가 추가됩니다.'
            }
          </h5>
          <div className="modal_content">
            <div className="inputText">
              <div className="title initial">
                <h4>매장명</h4>
              </div>
              <input
                type="text"
                placeholder="매장명을 입력해주세요"
                value={storeName}
                onChange={onChange_storeName}
                autoFocus={true}
              />
            </div>
            <div className="inputText">
              <div className="title">
                <h4>영문 매장명</h4>
              </div>
              <input
                type="text"
                placeholder="영문 매장명을 입력해주세요"
                value={storeNameEn}
                onChange={onChange_storeName_en}
                autoFocus={false}
              />
            </div>
            <div className="inputText">
              <div className="title">
                <h4>매장주소</h4>
              </div>
              <div className="address">
                <input
                  type="text"
                  disabled
                  value={sAddress}
                  placeholder="도로명 주소를 입력해주세요"
                  autoFocus={false}
                  style={{ marginBottom: '8px', backgroundColor: '#ffffff' }}
                />
                <button
                  className="searchBox"
                  onClick={() => {
                    setAddressModal(true);
                  }}>
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_search.svg`} alt="search" />
                </button>
              </div>
              <input
                type="text"
                placeholder="상세주소를 입력해주세요"
                value={sExtraAddress}
                onChange={onChange_sExtraAddress}
                autoFocus={false}
              />
            </div>
            <div className="inputText">
              <div className="title">
                <h4>매장 전화번호</h4>
              </div>
              <input
                type="number"
                placeholder="매장 전화번호를 입력해주세요"
                value={sPhoneNm}
                onChange={onChange_phoneNumber}
                autoFocus={false}
              />
            </div>
            <div className="inputText">
              <div className="title">
                <h4>로고 이미지</h4>
              </div>
              <div className="imageList logo">
                <input
                  id="multiLogoImage"
                  type="file"
                  name="photo"
                  accept="image/*"
                  autoFocus={false}
                  onChange={uploadLogoImage}
                />
                {multiLogoImage === '' || multiLogoImage === null ? (
                  <label className="photoBox logo" htmlFor="multiLogoImage">
                    <img src={`${process.env.PUBLIC_URL}/svg/ic_photo.svg`} alt="ic" />
                    <h5>이미지 추가</h5>
                  </label>
                ) : (
                  <div className="previewImageWrap logo">
                    <img className="previewImg" src={multiLogoImage} alt="img" />
                  </div>
                )}
                {multiLogoImage !== '' && multiLogoImage !== null && (
                  <label className="imageButton edit" htmlFor="multiLogoImage">
                    수정
                  </label>
                )}
                {multiLogoImage !== '' && multiLogoImage !== null && (
                  <button className="imageButton delete" onClick={deleteLogoImage}>
                    삭제
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="modal_footer">
            <button onClick={setMultiStore} className={`submitButton`}>
              멀티매장 추가하기
            </button>
          </div>
        </div>
      </Style>
      <CustomModal isVisible={addressModal} setVisible={setAddressModal}>
        <div style={{ display: 'flex' }}>
          <button
            onClick={handleAddressModalClose}
            style={{ marginLeft: 'auto', marginRight: '1%' }}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`} alt="ic" />
          </button>
        </div>
        <DaumPostcode
          onComplete={handleComplete}
          onClose={handleAddressModalClose}
          autoClose
          style={{ height: window.innerWidth > 1200 ? '54vh' : '70vh' }}
        />
      </CustomModal>
    </Modal>
  );
};

export default AddMultiStoreModal;

const Style = styled.div`
  .modal {
    position: relative;
    height: 87vh;
    padding: 4% 8%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .headerBar {
    width: 40px;
    height: 5px;
    background: #4dd2ae;
    border-radius: 10px;
  }
  .modal_header {
    padding-top: 2%;
    display: flex;
    flex-direction: column;
    align-items: center;
    white-space: pre-line;
    h2 {
      font-size: 22px;
      line-height: 32px;
      color: #555555;
      font-weight: 500;
      padding: 16px 0;
    }
  }

  h5.comment {
    font-size: 16px;
    line-height: 32px;
    color: #555555;
    font-weight: 500;
    /* padding-top: 5%; */
    white-space: pre-line;
  }

  .modal_content {
    padding: 28px 0;
  }
  .inputText {
    img {
      cursor: pointer;
    }

    .title {
      padding: 20px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 6px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }
  }
  .modal_footer {
    padding-bottom: 4%;
  }

  input,
  textarea {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #cecece;
    border-radius: 5px;
    color: #555555;
  }

  input::placeholder,
  textarea::placeholder {
    color: #cecece;
  }

  textarea {
    min-height: 120px;
  }

  /* 주소검색 */
  .address {
    position: relative;
    .searchBox {
      margin-bottom: 8px;
      position: absolute;
      top: 0;
      bottom: 0;
      padding: 8px 20px;
      border: none;
      background: #4dd2ae;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
      right: 0%;
    }
  }

  /* 이미지 */
  .imageButton {
    background: #ffffff;
    text-align: center;
    border-radius: 5px;
    padding: 6px 14px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
  }
  .imageButton.edit {
    border: 1px solid #cecece;
    color: #555555;
  }
  .imageButton.delete {
    border: 1px solid #4dd2ae;
    color: #4dd2ae;
  }

  .imageList {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 10px;
    flex-wrap: wrap;

    .row.between {
      align-items: flex-start;
    }

    .previewImageWrap {
      width: 120px;
      height: 120px;
      position: relative;
      .imageDeleteButton {
        position: absolute;
        top: 0;
        right: 0;
        width: 24px;
        height: 24px;
        border-radius: 0 5px 0 5px;
        background: rgba(0, 0, 0, 0.3);
      }
    }
    .previewImageWrap.logo {
      height: 102px;
    }

    .previewImg {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      object-fit: cover;
    }
    .previweImg.logo {
      height: 102px;
    }

    .photoBox {
      width: 120px;
      height: 120px;
      border-radius: 5px;
      padding: 10px;
      padding-top: 20px;
      border: 1px solid #cecece;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 6px;
      cursor: pointer;

      h5 {
        color: #a7a7a7;
        font-weight: 400;
      }
    }
    .photoBox.logo {
      height: 102px;
    }
  }
  .imageList.logo {
    align-items: flex-end;
  }

  input[type='file'] {
    display: none;
  }

  .submitButton {
    padding: 8px 12px;
    margin-top: 0;
  }

  @media (max-width: 900px) {
    .modal {
      padding: 4%;
    }
    h5.comment {
      padding: 0 4%;
      line-height: 20px;
      font-size: 14px;
    }
    .modal_footer {
      padding-bottom: 10%;
    }
  }
`;
